import { useEffect, useMemo, useState } from 'react';

import { execMeetingAPI } from '../../api/client';
import AppShell from '../../components/AppShell';
import { Page, PageHeader, PillTabs } from '../../components/ui';
import { canSeeMenu } from '../../utils/menuAccess';
import { COLORS } from '../../utils/uiStyles';
import { IconPresentation } from '@tabler/icons-react';
import AdminTab from './AdminTab';
import SubmitTab from './SubmitTab';
import UnifiedTab from './UnifiedTab';

const TABS = [['submit', '제출'], ['unified', '통합']];
// 관리자 탭(#3130) — 임원회의 관리(execmeeting-admin) 권한이 있을 때만 끝에 붙는다(서버도 같은 키로 403).
const ADMIN_TAB = ['admin', '관리자'];

function currentUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
}

export default function ExecMeetingPage() {
  const [activeTab, setActiveTab] = useState('submit');
  const [pingOK, setPingOK] = useState(null);
  const canAdmin = useMemo(() => canSeeMenu(currentUser(), 'execmeeting-admin'), []);
  const tabs = canAdmin ? [...TABS, ADMIN_TAB] : TABS;

  useEffect(() => {
    let alive = true;
    execMeetingAPI.ping()
      .then(() => { if (alive) setPingOK(true); })
      .catch(() => { if (alive) setPingOK(false); });
    return () => { alive = false; };
  }, []);

  return (
    <AppShell app="execmeeting" style={{ background: COLORS.bg, fontFamily: 'var(--gw-font)' }}>
      <main style={{ flex: 1, minWidth: 0, overflowY: 'auto' }}>
        <Page>
          <PageHeader
            icon={IconPresentation}
            tone="orange"
            title="임원회의"
            actions={pingOK !== null ? <span style={{ color: pingOK ? COLORS.successText : COLORS.dangerText, fontSize: '12px', alignSelf: 'center' }}>{pingOK ? '연결 확인됨' : '연결 실패'}</span> : null}
          />
          <PillTabs
            ariaLabel="임원회의 보기"
            idBase="exec-meeting-view"
            value={activeTab}
            onChange={setActiveTab}
            items={tabs.map(([key, label]) => ({ key, label }))}
          />
          <section role="tabpanel" id="exec-meeting-view-panel-submit" aria-labelledby="exec-meeting-view-tab-submit" hidden={activeTab !== 'submit'}><SubmitTab active={activeTab === 'submit'} /></section>
          {activeTab === 'unified' && <section role="tabpanel" id="exec-meeting-view-panel-unified" aria-labelledby="exec-meeting-view-tab-unified"><UnifiedTab /></section>}
          {canAdmin && activeTab === 'admin' && <section role="tabpanel" id="exec-meeting-view-panel-admin" aria-labelledby="exec-meeting-view-tab-admin"><AdminTab /></section>}
        </Page>
      </main>
    </AppShell>
  );
}
